export default __webpack_public_path__ + "static/media/Landing_Camera_Girl.b862bfba.png";